import { Box, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../../shared/components/ui/Card';
import { ModalDelete } from '../components/ModalDelete';
import { useUser } from '../context/useUser';
import { PageHeader } from '../components/UserDetail/PageHeader';
import { ActionButtons } from '../components/UserDetail/ActionButtons';
import { UserInfo } from '../components/UserDetail/UserInfo';

export default function UserDetailPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { 
    userData, 
    isDataLoading,
    openDeleteModal, 
    isDeleteModalOpen, 
    closeDeleteModal, 
    handleDeleteUser, 
    isDeleting, 
    navigateToEdit 
  } = useUser();

  if (isDataLoading) return null;
  if (!userData) return null;

  return (
    <Box sx={{ p: { xs: 1, md: 4 }, background: theme.palette.background.default, minHeight: '100vh' }}>
      <Card sx={{ background: theme.palette.background.paper, borderRadius: 4, p: 4, maxWidth: 900, margin: '32px auto', boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)' }}>
        <PageHeader onBack={() => navigate('/users')} />
        <ActionButtons 
          onEdit={() => navigateToEdit(userData.id)} 
          onDelete={() => openDeleteModal(userData)} 
        />
        <UserInfo user={userData} />

        <ModalDelete
          open={isDeleteModalOpen}
          onClose={closeDeleteModal}
          onConfirm={handleDeleteUser}
          loading={isDeleting}
          userName={userData.name}
        />
      </Card>
    </Box>
  );
}